// RETRIEVE & SET EXTERNAL INTEGRATIONS FOR USER
export const GET_USER_EXTERNAL_INTEGRATION_REQUEST = 'get_user_external_integration_request';
export const GET_USER_EXTERNAL_INTEGRATION_SUCCESS = 'get_user_external_integration_success';
export const GET_USER_EXTERNAL_INTEGRATION_FAILURE = 'get_user_external_integration_failure';